import { FeatureFlags as CatalogFeatureFlags } from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';

import { FeatureFlags as VizportalClientFeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

// This object is lazy-loaded because the feature flags aren't fully set up until after the app login
export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return {
    metricsDataCatalogEnabled: VizportalClientFeatureFlags.metricsDataCatalogEnabled,
    writableFieldDescriptionsEnabled: VizportalClientFeatureFlags.writableFieldDescriptionsEnabled,
    markupEditingEnabled: VizportalClientFeatureFlags.markupEditingEnabled,
    personalSpaceEnabled: true, //TODO: TFSID 1347914
    dqcertificationVisualDesignEnabled: true,
    fieldDescriptionInheritanceLineageEnabled: VizportalClientFeatureFlags.fieldDescriptionInheritanceLineageEnabled,
    incompleteCustomSqlEnabled: VizportalClientFeatureFlags.incompleteCustomSqlEnabled,
    publishedConnectionsLineageEnabled: VizportalClientFeatureFlags.publishedConnectionsLineageEnabled,
    databasesInProjectsEnabled: VizportalClientFeatureFlags.databasesInProjectsEnabled,
    lensLineageEnabled: VizportalClientFeatureFlags.askDataLensesInCatalogEnabled,
    relevantAssetsEnabled: VizportalClientFeatureFlags.relevantAssetsEnabled,
    columnDQWs: VizportalClientFeatureFlags.columnDQWsEnabled,
  };
});
